import { curry2 } from '@most/prelude';
export var error = curry2(function error(err, subject) {
    return subject.error(err);
});
//# sourceMappingURL=error.js.map